// // @flow

/* eslint-disable react/destructuring-assignment */
import { colors } from '@components/ListItemFacility/styles';
import React, { useEffect, useState, useRef } from 'react';
import { components } from 'react-select';

import { connect } from 'react-redux';
import compose from 'lodash/fp/compose';

import useDebounce from '@screens/Finder/Doctor/SearchBar/components/StyledSelect/debounce';
import { requestElasticSearch } from '@components/ElasticSearch/redux/actions';
import {
  StyledSelect, StyledSearchWrapper, StyledCustomIcon,
  StyledBox,
  StyledWrapper,
  StyledOuter
} from './styles';


const SearchBar = (props) => {
  const { requestElasticSearch, globalSearchResult } = props;
  const [searchResult, setSearchResult] = useState([]);
  const [focus, setFocus] = useState(false);

  const [isvisible, setVisible] = useState(true);

  const inputRef = useRef(null);

  const searchRef = useRef(null);

  const handleInputRef = (event) => {
    if (inputRef.current && inputRef.current.contains(event.target)) {
      return;
    }
    setVisible(false);
    props.setSearchState(false);
  };


  useEffect(() => {
    if (searchRef.current !== null) {
      searchRef.current.focus();
    }
    if (inputRef.current !== null) {
      inputRef.current.focus();
    }
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    // if(!isIOS){
    //   searchRef.current.focus();
    // }

    window.addEventListener('click', handleInputRef);
    return () => {
      window.removeEventListener('click', handleInputRef);
    };
  }, []);

  useEffect(() => {
    if (globalSearchResult.length > 0) {
      const tempArray = [];
      for (let i = 0; i < globalSearchResult.length; i += 1) {
        tempArray.push({
          label: `${globalSearchResult[i].attributes.search_type}#${globalSearchResult[i].attributes.name}`,
          value: globalSearchResult[i].id,
          url: globalSearchResult[i].attributes.landing_url
        });
      }
      setSearchResult([...tempArray]);
    }
  },
  [globalSearchResult]);


  const [searchQuery, setsearchQuery] = useState('');
  const debounceSearchTerm = useDebounce(searchQuery, 200);

  useEffect(() => {
    requestElasticSearch({ query: debounceSearchTerm });
  }, [debounceSearchTerm]);

  const handleInputChange = (inputValue, { action }) => {
    if (
      action !== 'input-blur'
      && action !== 'menu-close'
      && action !== 'set-value'
      && action !== 'input-blur'
      && action !== 'menu-close'
    ) {
      setsearchQuery(inputValue);
    }
    if (inputValue === '') {
      setSearchResult([]);
    }
  };

  const handleSelect = (option) => {
    const baseUrl = window.location.origin;
    const url = option.url.startsWith('/') ? option.url.slice(1) : option.url;
    const fullUrl = `${baseUrl}/${url}`;
    window.open(fullUrl, '_blank');
  };


  const NoOptionsMessage = props => (
    <components.NoOptionsMessage {...props}>
      {' '}
      {searchQuery ? 'No Results' : 'Type Something...'}
      {' '}
    </components.NoOptionsMessage>
  );

  const Option = props => (
    <React.Fragment>
      <components.Option {...props}>
        <StyledCustomIcon>
          {props.children.charAt(0) === 'D' && (
            <img src="../../../../static/images/svg/ElasticIcons/doctor.svg" alt="doctor" />
          )}
          {props.children.charAt(0) === 'T' && (
            <img src="../../../../static/images/svg/ElasticIcons/treatment.svg" alt="treatment" />
          )}
          {props.children.charAt(0) === 'F' && (
            <img src="../../../../static/images/svg/ElasticIcons/hospital.svg" alt="hospital" />
          )}
          <span>{props.children.split('#')[1]}</span>
        </StyledCustomIcon>
      </components.Option>

    </React.Fragment>
  );

  const customStyles = {
    option: (provided, state) => {
      const obj = {
        ...provided,
        cursor: 'pointer',
        color: `${colors.darkBlue}`,
        padding: 16,
        overflowWrap: 'break-word',
        hyphens: 'auto',
        '@media only screen and (max-width: 1024px)': {
          fontSize: '12px',
          padding: 10
        }
      };
      if (state.isSelected) {
        obj.backgroundColor = 'unset';
        obj.border = '2px solid blue';
        obj.color = `${colors.white};`;
      }
      return obj;
    },

    placeholder: provided => ({
      ...provided,
      fontSize: '20px',
      '@media only screen and (max-width: 1024px)': {
        fontSize: '14px'
      },
      '@media only screen and (max-width: 336px)': {
        fontSize: '10px'
      },
      '@media only screen and (max-width: 280px)': {
        fontSize: '8px'
      }
    }),

    menuList: base => ({
      ...base,
      paddingTop: '0px',
      paddingBottom: '0px',
      marginTop: '0px',
      '::-webkit-scrollbar': {
        width: '15px',
        '@media only screen and (max-width: 736px)': {
          width: '12px'
        }
      },
      '::-webkit-scrollbar-track': {
        background: 'white'
      },
      '::-webkit-scrollbar-thumb': {
        background: `${colors.translucentDarkBlue}`,
        borderRadius: '10px',
        height: '0',
        border: '5px solid white',
        '@media only screen and (max-width: 736px)': {
          border: '3px solid white'
        }
      }
    })
  };

  const customFilterOption = (option, inputValue) => {
    const normalize = str =>
      str
        .toLowerCase()
        .replace(/[^\w\s]/gi, '');

    return normalize(option.label).includes(normalize(inputValue));
  };

  return (
    <>
      {isvisible && (
        <>
          <StyledBox>
            <StyledOuter>
              <StyledWrapper>
                <StyledSearchWrapper
                  onFocus={() => setFocus(true)}
                  onBlur={() => setFocus(false)}
                  focus={focus}
                  ref={inputRef}
                  onTouchStart={() => setFocus(true)}
                >
                  <StyledSelect
                    {...props}
                    ref={searchRef}
                    id="mySelect"
                    styles={customStyles}
                    controlShouldRenderValue={false}
                    inputValue={searchQuery}
                    onInputChange={handleInputChange}
                    options={searchResult}
                    onChange={handleSelect}
                    components={{ Option, NoOptionsMessage }}
                    onSelectResetsInput={false}
                    closeMenuOnSelect={false}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    onFocus={() => setFocus(true)}
                    filterOption={customFilterOption}
                    onTouchStart={() => setFocus(true)}
                    placeholder="Search Treatments, Doctors and Hospitals..."
                  />
                </StyledSearchWrapper>

              </StyledWrapper>
            </StyledOuter>
          </StyledBox>
        </>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  globalSearchResult: state.elasticSearch.data
});

export default compose(
  connect(
    mapStateToProps,
    {
      requestElasticSearch
    }
  )
)(SearchBar);
